export const sum = (arr: number[]) => arr.reduce((value, acc) => value + acc, 0)

export const avg = (arr: number[]) => sum(arr) / arr.length